import React from "react"


export const PortfolioItem = ({ProjectTitle, ProjectType, ProjectDesc, ProjectImg, ProjectImgAlt, Children, ProjectLink}) => (
    <div className="relative z-10 flex flex-col py-8 lg:flex-row">
        <div className="relative z-10 flex-1 block pb-6 my-auto lg:mr-6 lg:pb-0">
            <h3 className="text-2xl font-bold">{ProjectTitle}</h3>
            <p className="inline-block px-2 py-1 my-2 text-sm rounded bg-gradient">{ProjectType}</p>
            <p className="pb-2 mb-4 md:pb-0">{ProjectDesc}</p>
            <a href={ProjectLink} className="btn-cta" target="_blank" rel="noopener noreferrer">Check it out!</a>
        </div>
        <div className="relative flex-1 block my-auto">
            <picture>
                <source srcset={`./${ProjectImg}`} type="image/webp" />
                <source srcset={`./${ProjectImgAlt}`} type="image/png" /> 
                <img src={`./${ProjectImgAlt}`} alt={ProjectTitle} className="relative z-10 w-full my-2 rounded shadow-2xl" />
            </picture>
            {Children}
        </div>
    </div>
)

export const PortfolioItemReveresed = ({ProjectTitle, ProjectType, ProjectDesc, ProjectImg, ProjectImgAlt, ProjectLink}) => (
    <div className="flex flex-col py-8 lg:flex-row-reverse lg:flex-row">
        <div className="relative z-20 flex-1 block pb-6 my-auto lg:pb-0 lg:ml-6">
            <h3 className="text-2xl font-bold">{ProjectTitle}</h3>
            <p className="inline-block px-2 py-1 my-2 text-sm rounded bg-gradient">{ProjectType}</p>
            <p className="pb-2 mb-4 md:pb-0">{ProjectDesc}</p>
            <a href={ProjectLink} className="btn-cta" target="_blank" rel="noopener noreferrer">Check it out!</a>
        </div>
        <div className="relative z-10 flex-1 block my-auto">
            <picture>
                <source srcset={`./${ProjectImg}`} type="image/webp" />
                <source srcset={`./${ProjectImgAlt}`} type="image/png" /> 
                <img src={`./${ProjectImgAlt}`} alt={ProjectTitle} className="relative z-10 w-full my-2 rounded shadow-2xl" />
            </picture>
        </div>
    </div>
)